<template>
  <modal :show="show" @close="close">
    <div class="modal-header">
      <h3>Create Organization</h3>
    </div>

    <div v-if="errors.length">
      <br/>
      <b>Please correct the following error(s):</b>
      <ul>
        <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
      </ul>
    </div>

    <div class="modal-body">
      <label class="form-label">
        Name
        <input type="text" v-model="name" class="form-control">
      </label>
    </div>

    <div class="modal-footer text-right">
      <v-btn color="deep-orange" dark @click="checkForm">
        Save
      </v-btn>
    </div>
  </modal>
</template>

<script>
import Modal from "./Modal";

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  name: "api-organization-modal",
  components: { Modal },
  props: ["auth", "show"],
  data() {
    return {
      errors: [],
      name: null
    };
  },
  methods: {
    checkForm() {
      this.errors = [];

      if (!this.name) {
        this.errors.push("Name required.");
      }

      if (!this.errors.length) {
        this.save();
      }
    },
    close() {
      this.$emit("close");
      this.errors = [];
      this.name = null;
    },
    save() {
      const body = {
        name: this.name
      };
      this.$http.post(`${API_ENDPOINT}/organization/`, body).then(
        () => {
          this.$parent.$emit("api-organization-update");
          this.close();
        },
        error => {
          console.error(`Error while saving object: ${error.statusText}`);
        }
      );
    }
  },
  mounted() {
    // Enter keypress
    document.addEventListener("keydown", e => {
      if (this.show && e.keyCode === 13) {
        this.checkForm();
      }
    });
  }
};
</script>

<style>
.button-success {
  color: #fff !important;
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
}
</style>
